import { createContext } from 'react'
import type { User } from '@/types/user-type'

export interface AuthContextType {
  userInfo?: User
  loading?: boolean
  isActive: boolean
  isAuthenticated: boolean
}

const AuthContext = createContext<AuthContextType | null>(null)
export default AuthContext
